import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ExtraPaymentRequest, PayrollRequest } from '../models/payroll.model';

@Injectable({
  providedIn: 'root'
})
export class PayrollService {
  private url = environment.api + "api/erp/payroll/";

  constructor(
    private http: HttpClient
  ) { }

  getSummaryContract(department: number, payment: number, startDate: number, endDate: number) {
    return this.http.get(this.url + `contract/summary?department=${department}&payment=${payment}&date=${startDate}&endDate=${endDate}`)
  }

  generatePayroll(newPayroll: PayrollRequest) {
    return this.http.post(this.url + 'payment/generate', newPayroll);
  }

  getContracted() {
    return this.http.get(this.url + "personal/employees/contracted");
  }

  getContractedData() {
    return this.http.get(this.url + "personal/employees/contracted/full");
  }

  getInactiveEmployees() {
    return this.http.get(this.url + "personal/employees/inactive/full");
  }

  getPersonalTotal() {
    return this.http.get(this.url + "personal/total");
  }

  getPersonalAssigned() {
    return this.http.get(this.url + "personal/assigned");
  }

  saveExtraPayment(type: number, newExtraPayment: ExtraPaymentRequest) {
    return this.http.post(this.url + "payment/scheduled?type=" + type, newExtraPayment);
  }

  getGeneratedPayroll(year: any, type: any) {
    return this.http.get(this.url + `payment/generated?year=${year}&type=${type}`);
  }

  createSuspension(data: any){
    return this.http.post(this.url + `contract/suspensions`, data);
  }

  getSuspensionStartEnd(start: any, end: any){
    return this.http.get(this.url + `contract/suspensions/dates/${start}/${end}`);
  }

  getSuspensionStart(start: any){
    return this.http.get(this.url + `contract/suspensions/dates/${start}`);
  }

  updateEndDateSuspension(id: number, endDate: number){
    return this.http.put(this.url + `contract/suspensions/${id}/end-dates/${endDate}`, {});
  }
}
